import api from '../token';

export const ListFormaPagamento = async () => {
  try {
    const response = await api.post('/getFormaPagamento');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

